import React, {useCallback, useEffect, useState} from "react";
import {SaleService} from "../sale/sale.service";
import CustomTextField from "../typescript/custom-text-field/custom-text-field";
import CustomRow from "../typescript/custom-row/custom-row";
import {DateUtil} from "../typescript/util/date-util";
import CustomPanel from "../typescript/custom-panel/custom-panel";
import CustomAreaChart from "../typescript/custom-area-chart/custom-area-chart";

const GraphProductConsumeByHour = () => {

    const curr = new Date();
    const [startDate, setStartDate] = useState(DateUtil.toJavaSqlDate(new Date(curr.getFullYear() - 1, curr.getMonth(), 1)));
    const [endDate, setEndDate] = useState(DateUtil.toJavaSqlDate(new Date(curr.getFullYear(), curr.getMonth(), 0)));
    const [graph, setGraph] = useState(null);

    const getGraph = useCallback(async () => {
        const result = await SaleService.produtosDeVendasFechadasPorHora(startDate, endDate);
        setGraph(result.data);
    }, [startDate, endDate]);

    const onChangeStartDate = (event) => {
        setStartDate(event.target.value)
    }

    const onChangeEndDate = (event) => {
        setEndDate(event.target.value)
    }

    useEffect(() => {
        getGraph().then();
    }, [getGraph]);

    return graph && (
        <CustomPanel title={"Quantidade de produtos de vendas fechadas por hora"}>
            <CustomAreaChart data={graph} dataKeyXAxis={"name"} name={"Produtos"} dataKey={"value"} labelX={"Hora"}
                             labelY={"Produtos"}/>
            <CustomRow>
                <CustomTextField fullWidth required label="Data inicial" type="date" value={startDate || ''}
                                 InputLabelProps={{shrink: true}} onChange={onChangeStartDate}/>
                <CustomTextField fullWidth required label="Data final" type="date" value={endDate || ''}
                                 InputLabelProps={{shrink: true}} onChange={onChangeEndDate}/>
            </CustomRow>
        </CustomPanel>
    );
}

export default React.memo(GraphProductConsumeByHour);